export const getLinkToPersonalData = () =>
    `${process.env.REACT_APP_PASSPORT_URL}/personal?dialog=personal-data`;

export const redirectToPersonalData = () => {
    window.open(getLinkToPersonalData());
};
